import React, { MouseEventHandler, useState } from 'react';
import { theme } from './theme';
import './DropdownItem.css';

interface DropdownItemProps {
	children: React.ReactNode;
	icon?: React.ReactNode;
	onClick?: MouseEventHandler<HTMLButtonElement>;
	disabled?: boolean;
}

const DropdownItem: React.FC<DropdownItemProps> = ({ children, icon, onClick, disabled }) => {
	const [isHovered, setIsHovered] = useState(false);
	const itemStyles = () => {
		const baseStyles = theme.item;
		const hoveredStyles = isHovered ? theme.itemHover : {};
		return {
			...baseStyles,
			...hoveredStyles
		};
	};

	return (
		<li
			style={itemStyles()}
			className={`dropdown-item  ${disabled ? 'disabled' : ''}`}
			role="menuitem"
			onMouseOver={() => setIsHovered(true)}
			onMouseOut={() => setIsHovered(false)}
		>
			<button
				style={theme.itemButton}
				onClick={onClick}
				className={`dropdown-item-button`}
				disabled={disabled}
			>
				{icon} {children}
			</button>
		</li>
	);
};

export default DropdownItem;
